import { useQuery } from "@tanstack/react-query"
import { useMutation } from "@tanstack/react-query"
import { hisApi } from "../api/hisApi"

export const useSearchHisPatient = () => {
   return useMutation({
    mutationFn: (hn: string) => hisApi.getPatientByHn(hn),
  })
  // return useQuery({
  //   queryKey: ["his-patient", hn],
  //   queryFn: () => hisApi.getPatientByHn(hn),
  //   enabled: false,
  // })
}